import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../container/context";
import comunidade from "../../../services/comunidade";
import Form from "../../../components/form";
import { formatToCurrency } from "../../../helpers/helpers";
import ActionTable from "../../../components/table/ActionTable";
import { Button, Stack } from "@mui/material";

export default function Produto(props) {
  const history = props.history;
  const [id] = useState(props.match.params.id);
  const [produto, setProduto] = useState({});
  const [pagamento, setPagamento] = useState({});
  const [inserindoPagamento, setInserindoPagamento] = useState(false);
  const { notification, confirm } = useContext(AppContext);
  const [opcoesPagamento, setOpcoesPagamento] = useState([]);
  const [dadosPagamento, setDadosPagamento] = useState({
    modalidade: 0,
    modalidadeNome: "",
    qtdParcelas: 0,
    valorParcela: 0,
    valorTotal: 0,
  });

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    comunidade
      .get("admin/produtos/carregar", { id: id })
      .then((res) => {
        setProduto(res);
        res.opcoesPagamento.forEach((item) => {
          if (item.modalidade === 1) item.modalidadeNome = "Boleto bancário";
          if (item.modalidade === 2) item.modalidadeNome = "Cartão de crédito";
          if (item.modalidade === 3) item.modalidadeNome = "Pix";

          item.parcelas.forEach((parcela) => {
            parcela.valorTotalFormat = formatToCurrency(parcela.valorTotal);
            parcela.valorFormat = formatToCurrency(parcela.valorParcela);
          });
        });
        setOpcoesPagamento(res.opcoesPagamento);
      })
      .catch((err) => {
        console.log("err", err);
        notification("error", "Erro ao carregar pedido");
      });
  };

  const editarProduto = (form) => {
    const dadosEnviar = form;
    dadosEnviar.id = id;

    comunidade
      .post("admin/produtos/editar", dadosEnviar)
      .then(() => {
        notification("success", "Produto editado");
        carregar();
      })
      .catch((err) => {
        console.log("err", err);
        notification("error", "Erro ao carregar pedido");
      });
  };

  const fDados = {
    title: "Produto",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 12,
        value: produto.nome,
      },
      descricao: {
        label: "Descrição",
        type: "text",
        space: 12,
        value: produto.descricao,
      },
    },
    submit: {
      label: "salvar",
      action: editarProduto,
    },

    history,
    close: {},
  };

  const montarTabelas = (tabela) => {
    return {
      title: tabela.modalidadeNome,
      newItemAction: () => {
        setDadosPagamento({
          ...dadosPagamento,
          modalidade: tabela.modalidade,
        });
        setPagamento(tabela);
        setInserindoPagamento(true);
      },

      onLineClick: (item) => {
        setDadosPagamento({
          ...dadosPagamento,
          produtoOpcaoPagamentoId: item.produtoOpcaoPagamentoId,
          modalidade: tabela.modalidade,
          modalidadeNome: tabela.modalidadeNome,
          qtdParcelas: item.qtd,
          valorParcela: item.valorParcela / 100,
          valorUnitarioCentavos: item.valorTotal / 100,
        });
        setPagamento(tabela);
        setInserindoPagamento(true);
      },
      columns: [
        {
          label: "Quantidade de Parcelas",
          name: "qtd",
        },
        {
          label: "Valor da parcela",
          name: "valorFormat",
        },
        {
          label: "Valor total",
          name: "valorTotalFormat",
        },
      ],
      array: tabela.parcelas,
    };
  };
  const salvarDados = (campo, valor) => {
    const dadosAtualizados = { ...dadosPagamento };

    if (campo === "modalidade") {
      dadosAtualizados["modalidade"] = valor;
      setDadosPagamento(dadosAtualizados);
    }

    if (pagamento.modalidade === 2) {
      if (campo === "qtdParcelas") {
        dadosAtualizados[campo] = valor;
        let total = valor * dadosPagamento.valorParcela;

        dadosAtualizados["valorUnitarioCentavos"] = total.toFixed(2);
        setDadosPagamento(dadosAtualizados);
      }
      if (campo === "valorParcela") {
        dadosAtualizados[campo] = Number(valor);
        let total = dadosPagamento.qtdParcelas * valor;

        dadosAtualizados["valorUnitarioCentavos"] = total.toFixed(2);
        setDadosPagamento(dadosAtualizados);
      }
      if (campo === "valorUnitarioCentavos") {
        dadosAtualizados[campo] = Number(valor);
        let total = Math.floor((valor * 100) / dadosPagamento.qtdParcelas);
        dadosAtualizados["valorParcela"] = (total / 100).toFixed(2);
        setDadosPagamento(dadosAtualizados);
      }
    } else {
      if (campo === "valorUnitarioCentavos") {
        dadosAtualizados[campo] = Number(valor);
        dadosAtualizados["valorParcela"] = Number(valor).toFixed(2);
        setDadosPagamento(dadosAtualizados);
      }
    }
  };

  const salvarPagamento = () => {
    const dadosEnviar = dadosPagamento;

    dadosEnviar.produtoId = id;

    if (typeof dadosEnviar.valorUnitarioCentavos === "string") {
      if (dadosEnviar.valorUnitarioCentavos.includes(".")) {
        dadosEnviar.valorUnitarioCentavos = Number(
          dadosEnviar.valorUnitarioCentavos.replace(".", "")
        );
      }
    } else {
      dadosEnviar.valorUnitarioCentavos =
        dadosPagamento.valorUnitarioCentavos * 100;
    }

    if (dadosPagamento.produtoOpcaoPagamentoId) {
      comunidade
        .post("admin/produtos/opcoesPagamento/editar", dadosEnviar)
        .then(() => {
          notification("success", "Parcela editada");
          setInserindoPagamento(false);
          setPagamento({});
          setDadosPagamento({
            modalidade: 0,
            modalidadeNome: "",
            qtdParcelas: 1,
            valorParcela: 0,
            valorTotal: 0,
          });
          carregar();
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Modalidade inválida");
            case 2:
              return notification("error", "Quantidade de parcelas inválida");
            case 3:
              return notification("error", "Valor unitário inválido");
            case 4:
              return notification(
                "error",
                "Opção de parcelamento já existente para a modalidade"
              );
            default:
              return notification("error", "Não foi possível salvar pagamento");
          }
        });
    } else {
      comunidade
        .post("admin/produtos/opcoesPagamento/inserir", dadosEnviar)
        .then(() => {
          notification("success", "Pagamento adicionado");
          setInserindoPagamento(false);
          setPagamento({});
          setDadosPagamento({
            modalidade: 0,
            modalidadeNome: "",
            qtdParcelas: 1,
            valorParcela: 0,
            valorTotal: 0,
          });
          carregar();
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Modalidade inválida");
            case 2:
              return notification("error", "Quantidade de parcelas inválida");
            case 3:
              return notification("error", "Valor unitário inválido");
            case 4:
              return notification(
                "error",
                "Opção de parcelamento já existente para a modalidade"
              );
            default:
              return notification("error", "Não foi possível salvar pagamento");
          }
        });
    }
  };

  const desativarPagamento = () => {
    confirm({
      title: "Confirma a inativação da opção de pagamento?",
      label: "A opção ficará indisponível em futuros pedidos.",
      onConfirm: () => {
        comunidade
          .post("admin/produtos/opcoesPagamento/inativar", {
            produtoOpcaoPagamentoId: dadosPagamento.produtoOpcaoPagamentoId,
          })
          .then(() => {
            notification("secondary", "opção de pagamento desativada");
            setInserindoPagamento(false);
            setPagamento({});
            setDadosPagamento({
              modalidade: 0,
              modalidadeNome: "",
              qtdParcelas: 1,
              valorParcela: 0,
              valorTotal: 0,
            });
            carregar();
          })
          .catch((err) => {
            notification("error", "Erro ao destaivar opção de pagamento");
          });
      },
    });
  };

  const montarFormPagamentos = () => {
    const campos = {
      modalidade: {
        label: "Modalidade",
        type: "select",
        readOnly: dadosPagamento.produtoOpcaoPagamentoId && true,
        emptyItem: true,
        emptyItemText: "(selecionar)",
        options: [
          {
            value: 1,
            desc: "Boleto bancário",
          },
          {
            value: 2,
            desc: "Cartão de crédito",
          },
          {
            value: 3,
            desc: "Pix",
          },
        ],
        value: dadosPagamento.produtoOpcaoPagamentoId
          ? dadosPagamento.modalidadeNome
          : dadosPagamento.modalidade,
      },
    };

    if (dadosPagamento.modalidade) {
      campos.qtdParcelas = {
        label: "Quantidade de parcelas",
        type: "number",
        space: 4,
        readOnly: dadosPagamento.modalidade !== 2 && true,
        value: dadosPagamento.modalidade !== 2 ? 1 : dadosPagamento.qtdParcelas,
      };
      campos.valorParcela = {
        label: "Valor da parcela",
        type: "number",
        space: 4,
        readOnly: dadosPagamento.modalidade !== 2 && true,
        value: dadosPagamento.valorParcela,
      };
      campos.valorUnitarioCentavos = {
        label: "Valor total",
        type: "number",
        space: 4,
        value: dadosPagamento.valorUnitarioCentavos,
      };
    }

    campos.componente = {
      type: "component",
      space: 12,
      value: (
        <>
          <Stack direction={"row"} spacing={2}>
            <Button
              style={{ color: "white" }}
              variant="contained"
              colo="primary"
              onClick={salvarPagamento}
            >
              Salvar
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setInserindoPagamento(false);
                setPagamento({});
                setDadosPagamento({
                  modalidade: 0,
                  qtdParcelas: 1,
                  valorParcela: 0,
                  valorTotal: 0,
                });
              }}
            >
              cancelar
            </Button>
            {dadosPagamento.produtoOpcaoPagamentoId && (
              <Button
                variant="outlined"
                color="warning"
                onClick={desativarPagamento}
              >
                desativar opção de pagamento
              </Button>
            )}
          </Stack>
        </>
      ),
    };

    return campos;
  };

  const fPagamento = {
    title: "Opção de pagamento",
    form: montarFormPagamentos(),
    autoSave: salvarDados,
  };

  return (
    <div>
      <Form formData={fDados} />

      {inserindoPagamento || pagamento.produtoOpcaoPagamentoId ? (
        <Form formData={fPagamento} />
      ) : (
        <>
          {opcoesPagamento.map((item) => (
            <ActionTable structure={montarTabelas(item)} />
          ))}
        </>
      )}
    </div>
  );
}
